import { Product, Category, Brand, Location, StockMovement, CartItem } from '../types';

// Mock data avec nouvelles structures
const mockProducts: Product[] = [
  {
    id: 'prod-1',
    reference: 'WURTH-VIS-001',
    codeArticle: 'WU6120ASSY',
    designation: 'Vis ASSY plus VG-T 6x120mm Würth',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777123456',
    prixUnitaireHT: 0.89,
    conditionnement: 'Boîte de 200 pièces',
    currentStock: 800,
    reservedStock: 20,
    seuilMin: 200,
    description: 'Vis universelle ASSY plus VG-T, tête fraisée, filetage partiel, pointe CUT, zinguée jaune. Idéale pour assemblages bois-bois en charpente.',
    image: 'https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-2',
    reference: 'WURTH-VIS-002',
    codeArticle: 'WU8160ASSY',
    designation: 'Vis ASSY plus VG-T 8x160mm Würth',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777123463',
    prixUnitaireHT: 1.45,
    conditionnement: 'Boîte de 100 pièces',
    currentStock: 400,
    reservedStock: 15,
    seuilMin: 100,
    description: 'Vis universelle ASSY plus VG-T, tête fraisée, filetage partiel, pointe CUT, zinguée jaune. Pour assemblages lourds en charpente.',
    image: 'https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-3',
    reference: 'WURTH-VIS-003',
    codeArticle: 'WU10200ASSY',
    designation: 'Vis ASSY plus VG-T 10x200mm Würth',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777123470',
    prixUnitaireHT: 2.15,
    conditionnement: 'Boîte de 50 pièces',
    currentStock: 200,
    reservedStock: 10,
    seuilMin: 50,
    description: 'Vis universelle ASSY plus VG-T, tête fraisée, filetage partiel, pointe CUT, zinguée jaune. Pour gros assemblages charpente.',
    image: 'https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-4',
    reference: 'WURTH-TIRE-001',
    codeArticle: 'WU12140TIRE',
    designation: 'Tire-fond Würth 12x140mm',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777234567',
    prixUnitaireHT: 3.25,
    conditionnement: 'Boîte de 25 pièces',
    currentStock: 150,
    reservedStock: 5,
    seuilMin: 50,
    description: 'Tire-fond tête hexagonale, filetage bois, zingué blanc. Pour fixations lourdes en charpente.',
    image: 'https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-5',
    reference: 'BOIS-001',
    codeArticle: 'SAPIN75X225',
    designation: 'Chevron sapin 75x225mm',
    categoryId: 'cat-2',
    brandId: 'brand-2',
    unit: 'm',
    prixUnitaireHT: 18.50,
    conditionnement: 'Barre de 4m',
    currentStock: 120,
    reservedStock: 5,
    seuilMin: 20,
    description: 'Chevron sapin du Nord, classe C24, séché, raboté 4 faces. Pour charpente traditionnelle.',
    image: 'https://images.pexels.com/photos/1693085/pexels-photo-1693085.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-2',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-6',
    reference: 'BOIS-002',
    codeArticle: 'SAPIN63X175',
    designation: 'Chevron sapin 63x175mm',
    categoryId: 'cat-2',
    brandId: 'brand-2',
    unit: 'm',
    prixUnitaireHT: 14.20,
    conditionnement: 'Barre de 4m',
    currentStock: 80,
    reservedStock: 8,
    seuilMin: 15,
    description: 'Chevron sapin du Nord, classe C24, séché, raboté 4 faces. Pour charpente courante.',
    image: 'https://images.pexels.com/photos/1693085/pexels-photo-1693085.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-2',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-7',
    reference: 'ISOLANT-001',
    codeArticle: 'LDV200GR32',
    designation: 'Laine de verre GR32 200mm',
    categoryId: 'cat-4',
    brandId: 'brand-6',
    unit: 'm2',
    prixUnitaireHT: 8.90,
    conditionnement: 'Rouleau de 6m² (1,2x5m)',
    currentStock: 45,
    reservedStock: 12,
    seuilMin: 20,
    description: 'Laine de verre lambda 0.032, revêtue kraft, épaisseur 200mm. Isolation thermique toiture.',
    image: 'https://images.pexels.com/photos/5691622/pexels-photo-5691622.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-4',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-8',
    reference: 'ECRAN-001',
    codeArticle: 'ECRANST150',
    designation: 'Écran sous-toiture HPV 150g/m²',
    categoryId: 'cat-5',
    brandId: 'brand-7',
    unit: 'm2',
    prixUnitaireHT: 2.45,
    conditionnement: 'Rouleau de 75m² (1,5x50m)',
    currentStock: 225,
    reservedStock: 75,
    seuilMin: 150,
    description: 'Écran sous-toiture haute perméabilité à la vapeur d\'eau, résistant aux UV. Pose sur chevrons.',
    image: 'https://images.pexels.com/photos/5691622/pexels-photo-5691622.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-5',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-9',
    reference: 'WURTH-CHEV-001',
    codeArticle: 'WU8X260CHEV',
    designation: 'Cheville à frapper Würth 8x260mm',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777345678',
    prixUnitaireHT: 1.85,
    conditionnement: 'Boîte de 50 pièces',
    currentStock: 300,
    reservedStock: 25,
    seuilMin: 100,
    description: 'Cheville à frapper pour fixation dans béton et maçonnerie. Galvanisée à chaud.',
    image: 'https://images.pexels.com/photos/209235/pexels-photo-209235.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-10',
    reference: 'CHIMIE-001',
    codeArticle: 'COLLE310PU',
    designation: 'Colle polyuréthane 310ml Würth',
    categoryId: 'cat-3',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777456789',
    prixUnitaireHT: 12.50,
    conditionnement: 'Cartouche de 310ml',
    currentStock: 24,
    reservedStock: 2,
    seuilMin: 12,
    description: 'Colle polyuréthane monocomposant, durcissement à l\'humidité. Excellente adhérence sur bois.',
    image: 'https://images.pexels.com/photos/8985441/pexels-photo-8985441.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-6',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-11',
    reference: 'WURTH-ANGL-001',
    codeArticle: 'WU90X90X65',
    designation: 'Équerre de charpente 90x90x65mm Würth',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777567890',
    prixUnitaireHT: 4.25,
    conditionnement: 'À l\'unité',
    currentStock: 60,
    reservedStock: 8,
    seuilMin: 20,
    description: 'Équerre de charpente galvanisée à chaud, perforée. Pour assemblages d\'angle en charpente.',
    image: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-12',
    reference: 'BOIS-003',
    codeArticle: 'SAPIN100X100',
    designation: 'Poteau sapin 100x100mm',
    categoryId: 'cat-2',
    brandId: 'brand-2',
    unit: 'm',
    prixUnitaireHT: 22.50,
    conditionnement: 'Barre de 4m',
    currentStock: 32,
    reservedStock: 4,
    seuilMin: 12,
    description: 'Poteau sapin du Nord, classe C24, séché, raboté 4 faces. Pour poteaux et montants.',
    image: 'https://images.pexels.com/photos/1693085/pexels-photo-1693085.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-2',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-13',
    reference: 'ISOLANT-002',
    codeArticle: 'LDV160GR32',
    designation: 'Laine de verre GR32 160mm',
    categoryId: 'cat-4',
    brandId: 'brand-6',
    unit: 'm2',
    prixUnitaireHT: 7.20,
    conditionnement: 'Rouleau de 7,2m² (1,2x6m)',
    currentStock: 65,
    reservedStock: 18,
    seuilMin: 30,
    description: 'Laine de verre lambda 0.032, revêtue kraft, épaisseur 160mm. Isolation thermique combles.',
    image: 'https://images.pexels.com/photos/5691622/pexels-photo-5691622.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-4',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-14',
    reference: 'WURTH-SABOT-001',
    codeArticle: 'WU75X175SAB',
    designation: 'Sabot de charpente 75x175mm Würth',
    categoryId: 'cat-1',
    brandId: 'brand-5',
    unit: 'piece',
    barcode: '4046777678901',
    prixUnitaireHT: 6.80,
    conditionnement: 'À l\'unité',
    currentStock: 40,
    reservedStock: 6,
    seuilMin: 15,
    description: 'Sabot de charpente galvanisé à chaud, pour liaison poteau-poutre. Avec vis de fixation.',
    image: 'https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-1',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 'prod-15',
    reference: 'CHIMIE-002',
    codeArticle: 'MASTIC300AC',
    designation: 'Mastic acrylique 300ml blanc',
    categoryId: 'cat-3',
    brandId: 'brand-8',
    unit: 'piece',
    prixUnitaireHT: 4.90,
    conditionnement: 'Cartouche de 300ml',
    currentStock: 36,
    reservedStock: 4,
    seuilMin: 18,
    description: 'Mastic acrylique blanc, peinture possible. Pour joints d\'étanchéité intérieur.',
    image: 'https://images.pexels.com/photos/8985441/pexels-photo-8985441.jpeg?auto=compress&cs=tinysrgb&w=400',
    defaultLocationId: 'loc-6',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  }
];

const mockCategories: Category[] = [
  { id: 'cat-1', name: 'Quincaillerie Charpente', description: 'Vis, tire-fonds, chevilles, équerres, sabots, connecteurs', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'cat-2', name: 'Bois de Charpente', description: 'Chevrons, poutres, planches, madriers, poteaux', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'cat-3', name: 'Produits Chimiques', description: 'Colles, mastics, traitements bois, lasures', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'cat-4', name: 'Isolation', description: 'Laine de verre, laine de roche, panneaux isolants', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'cat-5', name: 'Écrans & Membranes', description: 'Écrans sous-toiture, pare-vapeur, membranes d\'étanchéité', createdAt: '2024-01-01T00:00:00Z' }
];

const mockBrands: Brand[] = [
  { id: 'brand-1', name: 'Spax', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-2', name: 'Scieries du Nord', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-3', name: 'Titebond', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-4', name: 'Simpson Strong-Tie', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-5', name: 'Würth', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-6', name: 'Isover', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-7', name: 'Dupont Tyvek', createdAt: '2024-01-01T00:00:00Z' },
  { id: 'brand-8', name: 'Sika', createdAt: '2024-01-01T00:00:00Z' }
];

const mockLocations: Location[] = [
  { 
    id: 'loc-1', 
    magasin: 'Dépôt Principal',
    allee: 'A',
    travee: '1',
    bac: 'B01',
    fullCode: 'DP-A1-B01',
    commentaire: 'Quincaillerie - Visserie et fixations',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  },
  { 
    id: 'loc-2', 
    magasin: 'Dépôt Principal',
    allee: 'B',
    travee: '2',
    bac: 'R01',
    fullCode: 'DP-B2-R01',
    commentaire: 'Rack bois - Chevrons et poutres',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  },
  { 
    id: 'loc-3', 
    magasin: 'Dépôt Principal',
    allee: 'C',
    travee: '1',
    bac: 'A01',
    fullCode: 'DP-C1-A01',
    commentaire: 'Armoire produits chimiques',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  },
  { 
    id: 'loc-4', 
    magasin: 'Dépôt Principal',
    allee: 'D',
    travee: '1',
    bac: 'I01',
    fullCode: 'DP-D1-I01',
    commentaire: 'Zone isolation - Rouleaux',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  },
  { 
    id: 'loc-5', 
    magasin: 'Dépôt Principal',
    allee: 'D',
    travee: '2',
    bac: 'E01',
    fullCode: 'DP-D2-E01',
    commentaire: 'Zone étanchéité - Écrans et membranes',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  },
  { 
    id: 'loc-6', 
    magasin: 'Dépôt Principal',
    allee: 'C',
    travee: '2',
    bac: 'A02',
    fullCode: 'DP-C2-A02',
    commentaire: 'Armoire chimie - Colles et mastics',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z' 
  }
];

const mockMovements: StockMovement[] = [
  {
    id: 'mov-1',
    date: '2024-12-10T10:00:00Z',
    type: 'ENTREE',
    productId: 'prod-1',
    reference: 'WURTH-VIS-001',
    quantity: 100,
    destinationLocationId: 'loc-1',
    docSource: { id: 'achat-1', type: 'commande_fournisseur' },
    userId: '2',
    commentaire: 'Réception commande fournisseur Würth',
    createdAt: '2024-12-10T10:00:00Z'
  },
  {
    id: 'mov-2',
    date: '2024-12-12T14:30:00Z',
    type: 'SORTIE',
    productId: 'prod-1',
    reference: 'WURTH-VIS-001',
    quantity: -30,
    sourceLocationId: 'loc-1',
    chantierId: 'chantier-1',
    docSource: { id: 'order-chantier-1', type: 'commande_chantier' },
    userId: '3',
    commentaire: 'Sortie chantier Maison Dupont',
    createdAt: '2024-12-12T14:30:00Z'
  },
  {
    id: 'mov-3',
    date: '2024-12-01T16:00:00Z',
    type: 'AJUSTEMENT',
    productId: 'prod-5',
    reference: 'BOIS-001',
    quantity: -2,
    sourceLocationId: 'loc-2',
    userId: '2',
    commentaire: 'Ajustement inventaire - chevrons abîmés',
    createdAt: '2024-12-01T16:00:00Z'
  }
];

class ProductService {
  async getProducts(filters?: {
    search?: string;
    categoryId?: string;
    brandId?: string;
    alertOnly?: boolean;
  }): Promise<Product[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    let filtered = [...mockProducts];
    
    if (filters?.search) {
      const search = filters.search.toLowerCase();
      filtered = filtered.filter(p => 
        p.reference.toLowerCase().includes(search) ||
        p.codeArticle.toLowerCase().includes(search) ||
        p.designation.toLowerCase().includes(search) ||
        p.barcode?.toLowerCase().includes(search)
      );
    }
    
    if (filters?.categoryId) {
      filtered = filtered.filter(p => p.categoryId === filters.categoryId);
    }
    
    if (filters?.brandId) {
      filtered = filtered.filter(p => p.brandId === filters.brandId);
    }
    
    if (filters?.alertOnly) {
      filtered = filtered.filter(p => p.currentStock <= p.seuilMin);
    }
    
    return filtered;
  }

  async getProduct(id: string): Promise<Product | null> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockProducts.find(p => p.id === id) || null;
  }

  async getProductByBarcode(barcode: string): Promise<Product | null> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockProducts.find(p => p.barcode === barcode) || null;
  }

  async getProductByReference(reference: string): Promise<Product | null> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockProducts.find(p => p.reference === reference) || null;
  }

  async createProduct(product: Omit<Product, 'id' | 'createdAt' | 'updatedAt' | 'currentStock' | 'reservedStock'>): Promise<Product> {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Vérifier l'unicité de la référence
    if (mockProducts.some(p => p.reference === product.reference)) {
      throw new Error('Cette référence existe déjà');
    }
    
    const newProduct: Product = {
      ...product,
      id: `prod-${Date.now()}`,
      currentStock: 0,
      reservedStock: 0,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    mockProducts.push(newProduct);
    return newProduct;
  }

  async updateProduct(id: string, updates: Partial<Product>): Promise<Product> {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const index = mockProducts.findIndex(p => p.id === id);
    if (index === -1) throw new Error('Produit non trouvé');
    
    // Vérifier l'unicité de la référence si modifiée
    if (updates.reference && updates.reference !== mockProducts[index].reference) {
      if (mockProducts.some(p => p.reference === updates.reference && p.id !== id)) {
        throw new Error('Cette référence existe déjà');
      }
    }
    
    mockProducts[index] = {
      ...mockProducts[index],
      ...updates,
      updatedAt: new Date().toISOString()
    };
    
    return mockProducts[index];
  }

  async deleteProduct(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const index = mockProducts.findIndex(p => p.id === id);
    if (index !== -1) {
      mockProducts.splice(index, 1);
    }
  }

  async adjustStock(productId: string, quantity: number, reason: string, userId: string, locationId?: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const product = mockProducts.find(p => p.id === productId);
    if (!product) throw new Error('Produit non trouvé');
    
    const oldStock = product.currentStock;
    product.currentStock += quantity;
    product.updatedAt = new Date().toISOString();
    
    // Ajouter le mouvement
    const movement: StockMovement = {
      id: `mov-${Date.now()}`,
      date: new Date().toISOString(),
      type: 'AJUSTEMENT',
      productId,
      reference: product.reference,
      quantity,
      sourceLocationId: quantity < 0 ? (locationId || product.defaultLocationId) : undefined,
      destinationLocationId: quantity > 0 ? (locationId || product.defaultLocationId) : undefined,
      userId,
      commentaire: reason,
      createdAt: new Date().toISOString()
    };
    
    mockMovements.unshift(movement);
  }

  async transferStock(productId: string, fromLocationId: string, toLocationId: string, quantity: number, userId: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const product = mockProducts.find(p => p.id === productId);
    if (!product) throw new Error('Produit non trouvé');
    
    const movement: StockMovement = {
      id: `mov-${Date.now()}`,
      date: new Date().toISOString(),
      type: 'TRANSFERT',
      productId,
      reference: product.reference,
      quantity,
      sourceLocationId: fromLocationId,
      destinationLocationId: toLocationId,
      userId,
      commentaire: `Transfert de ${this.getLocationName(fromLocationId)} vers ${this.getLocationName(toLocationId)}`,
      createdAt: new Date().toISOString()
    };
    
    mockMovements.unshift(movement);
  }

  async getStockMovements(productId?: string, filters?: {
    startDate?: string;
    endDate?: string;
    type?: string;
    chantierId?: string;
  }): Promise<StockMovement[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    let filtered = [...mockMovements];
    
    if (productId) {
      filtered = filtered.filter(m => m.productId === productId);
    }
    
    if (filters?.startDate) {
      filtered = filtered.filter(m => m.date >= filters.startDate!);
    }
    
    if (filters?.endDate) {
      filtered = filtered.filter(m => m.date <= filters.endDate!);
    }
    
    if (filters?.type) {
      filtered = filtered.filter(m => m.type === filters.type);
    }
    
    if (filters?.chantierId) {
      filtered = filtered.filter(m => m.chantierId === filters.chantierId);
    }
    
    return filtered.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

  // Categories
  async getCategories(): Promise<Category[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return [...mockCategories];
  }

  async createCategory(category: Omit<Category, 'id' | 'createdAt'>): Promise<Category> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const newCategory: Category = {
      ...category,
      id: `cat-${Date.now()}`,
      createdAt: new Date().toISOString()
    };
    
    mockCategories.push(newCategory);
    return newCategory;
  }

  async updateCategory(id: string, updates: Partial<Category>): Promise<Category> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const index = mockCategories.findIndex(c => c.id === id);
    if (index === -1) throw new Error('Catégorie non trouvée');
    
    mockCategories[index] = { ...mockCategories[index], ...updates };
    return mockCategories[index];
  }

  async deleteCategory(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const index = mockCategories.findIndex(c => c.id === id);
    if (index !== -1) {
      mockCategories.splice(index, 1);
    }
  }

  // Brands
  async getBrands(): Promise<Brand[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return [...mockBrands];
  }

  async createBrand(brand: Omit<Brand, 'id' | 'createdAt'>): Promise<Brand> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const newBrand: Brand = {
      ...brand,
      id: `brand-${Date.now()}`,
      createdAt: new Date().toISOString()
    };
    
    mockBrands.push(newBrand);
    return newBrand;
  }

  async updateBrand(id: string, updates: Partial<Brand>): Promise<Brand> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const index = mockBrands.findIndex(b => b.id === id);
    if (index === -1) throw new Error('Marque non trouvée');
    
    mockBrands[index] = { ...mockBrands[index], ...updates };
    return mockBrands[index];
  }

  async deleteBrand(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const index = mockBrands.findIndex(b => b.id === id);
    if (index !== -1) {
      mockBrands.splice(index, 1);
    }
  }

  // Locations
  async getLocations(): Promise<Location[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return [...mockLocations];
  }

  async createLocation(location: Omit<Location, 'id' | 'createdAt' | 'fullCode'>): Promise<Location> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const fullCode = `${location.magasin.substring(0, 2).toUpperCase()}-${location.allee}${location.travee}-${location.bac}`;
    
    const newLocation: Location = {
      ...location,
      id: `loc-${Date.now()}`,
      fullCode,
      createdAt: new Date().toISOString()
    };
    
    mockLocations.push(newLocation);
    return newLocation;
  }

  async updateLocation(id: string, updates: Partial<Location>): Promise<Location> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const index = mockLocations.findIndex(l => l.id === id);
    if (index === -1) throw new Error('Emplacement non trouvé');
    
    const updated = { ...mockLocations[index], ...updates };
    
    // Recalculer le code complet si nécessaire
    if (updates.magasin || updates.allee || updates.travee || updates.bac) {
      updated.fullCode = `${updated.magasin.substring(0, 2).toUpperCase()}-${updated.allee}${updated.travee}-${updated.bac}`;
    }
    
    mockLocations[index] = updated;
    return mockLocations[index];
  }

  async deleteLocation(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const index = mockLocations.findIndex(l => l.id === id);
    if (index !== -1) {
      mockLocations.splice(index, 1);
    }
  }

  // Helper methods
  getCategoryName(categoryId: string): string {
    const category = mockCategories.find(c => c.id === categoryId);
    return category?.name || 'Catégorie inconnue';
  }

  getBrandName(brandId: string): string {
    const brand = mockBrands.find(b => b.id === brandId);
    return brand?.name || 'Marque inconnue';
  }

  getLocationName(locationId: string): string {
    const location = mockLocations.find(l => l.id === locationId);
    return location?.fullCode || 'Emplacement inconnu';
  }

  getLocationFullName(locationId: string): string {
    const location = mockLocations.find(l => l.id === locationId);
    if (!location) return 'Emplacement inconnu';
    return `${location.fullCode} - ${location.commentaire || location.magasin}`;
  }

  isStockAlert(product: Product): boolean {
    return product.currentStock <= product.seuilMin;
  }

  getAvailableStock(product: Product): number {
    return Math.max(0, product.currentStock - product.reservedStock);
  }

  getProductName(productId: string): string {
    const product = mockProducts.find(p => p.id === productId);
    return product?.designation || 'Produit inconnu';
  }

  getProductReference(productId: string): string {
    const product = mockProducts.find(p => p.id === productId);
    return product?.reference || 'REF-INCONNUE';
  }

  getUnitLabel(unit: Product['unit']): string {
    const labels: Record<Product['unit'], string> = {
      piece: 'pièce(s)',
      m: 'mètre(s)',
      m2: 'm²',
      kg: 'kg',
      l: 'litre(s)',
      ml: 'ml',
      cm: 'cm',
      mm: 'mm'
    };
    return labels[unit] || unit;
  }

  async getSimilarProducts(productId: string): Promise<Product[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const product = mockProducts.find(p => p.id === productId);
    if (!product) return [];
    
    return mockProducts.filter(p => 
      p.id !== productId && 
      p.categoryId === product.categoryId && 
      p.isActive &&
      this.getAvailableStock(p) > 0
    ).slice(0, 3);
  }

  // Calculs de stock
  calculateReservedStock(productId: string): number {
    // En réalité, cela calculerait le stock réservé basé sur les commandes en cours
    return mockProducts.find(p => p.id === productId)?.reservedStock || 0;
  }

  calculateCurrentStock(productId: string): number {
    // En réalité, cela calculerait le stock actuel basé sur les mouvements
    const product = mockProducts.find(p => p.id === productId);
    if (!product) return 0;
    
    const movements = mockMovements.filter(m => m.productId === productId);
    const totalMovements = movements.reduce((sum, m) => sum + m.quantity, 0);
    
    return Math.max(0, totalMovements);
  }
}

export const productService = new ProductService();